import { Dialog } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import type { TPledgeAutoFields } from 'entities/pledgeAutoForm';

//  TODO разобраться со структурой (feature / entity)
// eslint-disable-next-line boundaries/element-types
import { PledgeAutoForm } from 'features/PledgeAutoForm';

import { PledgeAutoTexts } from './PledgeAuto.texts';
import styles from './PledgeAutoPopup.module.scss';

interface IProps {
  isShowPopup: boolean;
  onClosePopup: () => void;
  onSubmit: (data: TPledgeAutoFields) => Promise<void>;
  isSubmitting?: boolean;
  isRequiredCarNumber?: boolean;
}

export const PledgeAutoPopup = (props: IProps) => {
  const { isShowPopup, onClosePopup, onSubmit, isSubmitting, isRequiredCarNumber = false } = props;
  const isMobile = useIsMobile();
  return (
    <Dialog
      visible={isShowPopup || isSubmitting}
      closable
      onClose={onClosePopup}
      fullscreen={isMobile}
      className={styles.dialogPopup}
    >
      <Dialog.Header title={PledgeAutoTexts.popupHeader} />
      <Dialog.Content>
        <PledgeAutoForm
          submitButtonText={PledgeAutoTexts.submitButtonLabel}
          onFormSubmit={onSubmit}
          isLoading={isSubmitting}
          isRequiredCarNumber={isRequiredCarNumber}
        />
      </Dialog.Content>
    </Dialog>
  );
};
